'use client';

import React, { useEffect, useState } from 'react';
import { IconSlider } from './IconSlider';
import {
  StrapiIconSlider,
  IconSliderData,
  BackgroundType,
} from '@/types/iconSlider';
import { usePageTheme } from '@/stores/page-theme';

interface IconSliderWrapperProps {
  strapiData: StrapiIconSlider;
  bgColor?: string;
}

export const IconSliderWrapper: React.FC<IconSliderWrapperProps> = ({
  strapiData,
  bgColor,
}) => {
  const [data, setData] = useState<IconSliderData>({
    title: '',
    headingSize: 'h3',
    headingColor: '',
    shadowText: false,
    background: 'inherit',
    backgroundColor: '',
    backgroundImage: '',
    theme: 'default',
    slides: [],
    pageTheme: 'default',
    bgColor: '',
    iconBGColor: '#CFECFF',
    iconTextColor: '#1C8EFF',
    iconImage: '',
    buttonBGColor: '#FFFFFF',
    buttonTextColor: '#1C8EFF',
  });
  const { bgColor: themeBgColor } = usePageTheme();

  useEffect(() => {
    try {
      const transformedData: IconSliderData = {
        title: strapiData?.title || '',
        headingSize: strapiData?.headingSize?.size || 'h3',
        headingColor: strapiData?.headingColor || '',
        shadowText: strapiData?.shadowText || false,
        background:
          (strapiData?.background?.style as BackgroundType) || 'inherit',
        backgroundColor: strapiData?.backgroundColor || '',
        backgroundImage: strapiData?.background?.url || '',
        theme: strapiData?.theme || 'default',
        slides: (strapiData?.slides || [])
          .filter((slide) => !slide.hidden)
          .map((slide) => ({
            id: slide.id,
            text: slide.text || '',
            icon: slide.icon ? { name: slide.icon.name } : undefined,
            iconBGColor: slide.iconBGColor || '#CFECFF',
            iconTextColor: slide.iconTextColor || '#1C8EFF',
            iconImage: slide.iconImage || '',
            whiteText: slide.whiteText || false,
            hidden: slide.hidden || false,
          })),
        pageTheme: strapiData?.theme || 'default',
        bgColor: bgColor || themeBgColor || '',
        mainIcon: strapiData?.mainIcon
          ? { name: strapiData.mainIcon.name }
          : undefined,
        iconBGColor: strapiData?.iconBGColor || '#CFECFF',
        iconTextColor: strapiData?.iconTextColor || '#1C8EFF',
        iconImage: strapiData?.iconImage || '',
        buttonBGColor: strapiData?.buttonBGColor || '#FFFFFF',
        buttonTextColor: strapiData?.buttonTextColor || '#1C8EFF',
      };

      setData(transformedData);
    } catch (error) {
      console.error('Error transforming IconSlider data:', error);
    }
  }, [strapiData, bgColor, themeBgColor]);

  return <IconSlider {...data} />;
};
